import styled from "styled-components";

export const Container = styled.div`
  margin: 10px;
  padding: 15px;
  border: 4px solid var(--secondary-color);
  border-radius: 5px;
`;
